import { tracking } from '@iwoca/frontend-tracking-library';
import { Switch } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.context';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { getAmplitudeDefaultEventProperties } from 'utils/amplitudeEvents';
import styles from './ManagedByIwocaToggle.module.css';

export const ManagedByIwocaToggle = () => {
  const { searchApplicationPartnerChannelToggle } = useDashboard();

  const { includePartnerChannel, setIncludePartnerChannel } =
    useApplicationsTableState();

  const handleChange = (prevValue: boolean) => {
    tracking.ampli.ctaClick({
      ...getAmplitudeDefaultEventProperties(),
      'CTA text': 'Show managed by iwoca apps',
    });
    setIncludePartnerChannel(!prevValue);
    searchApplicationPartnerChannelToggle(!prevValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.toggleContainer}>
        <h3 className={styles.heading}>
          <Trans>Show managed by iwoca apps</Trans>
        </h3>
        <Switch
          data-testid="managed-by-iwoca-switch"
          checked={includePartnerChannel}
          onClick={() => handleChange(includePartnerChannel)}
        />
      </div>
      <p className={styles.subHeading}>
        <Trans>
          These applications are managed by iwoca and can only be viewed.
        </Trans>
      </p>
    </div>
  );
};
